namespace GeniuzPOS.Inventory {
    export interface IcStkmedthodForm {
        Stkmedthod: Serenity.StringEditor;
        StkmedthodName: Serenity.StringEditor;
    }

    export class IcStkmedthodForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStkmedthod';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStkmedthodForm.init)  {
                IcStkmedthodForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(IcStkmedthodForm, [
                    'Stkmedthod', w0,
                    'StkmedthodName', w0
                ]);
            }
        }
    }
}
